function parallaxStory() {
  const elsLeft = document.querySelectorAll('.story-parallax');
  const elsRight = document.querySelectorAll('.story-parallax-alt');
  if (elsLeft.length === 0 || elsRight.length === 0) {
    return;
  }
  new simpleParallax(elsLeft, {
    scale: 1.1,
    overflow: true,
    orientation: 'up'
  });
  new simpleParallax(elsRight, {
    scale: 1.1,
    overflow: true,
    orientation: 'down'
  });
}

window.addEventListener('DOMContentLoaded', function () {
  parallaxStory();
});